<template>
  <div class="bbb-pages">
    <div class="bbb-how-to">
      <ul class="vn">
        <li class="three-points">
          <strong>+3 POINTS</strong>
          <p>3x tap to snatch</p>
        </li>
        <li class="two-points">
          <strong>+2 POINTS</strong>
          <p>2x tap to snatch</p>
        </li>
        <li class="one-point">
          <strong>+1 POINT</strong>
          <p>1x tap to snatch</p>
        </li>
        <li class="minus-two-points">
          <strong>-2 POINTS</strong>
          <p>
            Don't tap <br />
            Mr. RX photo!
          </p>
        </li>
      </ul>
      <br /><br />
      <div class="how-to-play-section">
        <h2 class="how-to-play-title">How to Play</h2>

        <ul class="how-to-play-list">
          <li class="how-to-play-item">
            <span class="bullet">1</span>
            <p>
              Tap produk COSRX <b>dalam 15 detik</b>. Kumpulkan poin berbeda untuk setiap produk.
              <b>Hati-hati, jangan tap foto Mr. RX atau poinmu berkurang!</b>
            </p>
          </li>

          <li class="how-to-play-item">
            <span class="bullet">2</span>
            <p>Capai skor tertentu & dapatkan freebies dari COSRX (selama stok tersedia).</p>
          </li>

          <li class="how-to-play-item">
            <span class="bullet">3</span>
            <p>Syarat & Ketentuan dapat berubah sewaktu-waktu tanpa pemberitahuan.</p>
          </li>
        </ul>

        <div class="button-container">
          <button class="btn-back btn" @click="goBackToHome">Back to Home</button>
          <button class="btn-play btn" @click="startGame">Play Now</button>
        </div>
      </div>
      <!-- <p>How to play</p>
      <ol>
        <li>Hancurkan meteor yang muncul di galaxy dalam waktu <strong>15 detik</strong></li>
        <li>
          Masing-masing meteor memiliki <strong>POIN</strong> untuk dikumpulkan. Hati-hati, star
          <strong>tidak boleh</strong> di-tap karena akan <strong>mengurangi</strong> jumlah poin yang sudah kamu
          kumpulkan.
        </li>
        <li>Kamu akan mendapatkan <strong>freebies</strong> bila mengumpulkan diatas <strong>50 poin</strong>.</li>
      </ol>
              <router-link to="/cosrx-vending-machine-event/bbb-game-start" tag="button">Main Sekarang</router-link> -->
    </div>
  </div>
</template>

<script>
import VendingMachineTracker from '@/mixins/vending-machine-tracker';
import connectionHelper from '@/mixins/connection-helper.js';

export default {
  name: 'PimplePopHowToPlay',
  mixins: [VendingMachineTracker, connectionHelper],
  data() {
    return {
      idleTimer: null,
      idleTimeout: 30000,
    };
  },
  computed: {
    isVnSource() {
      return this.$route.query.isvn;
    },
    url_next() {
      return '/cosrx-vending-machine-event/home';
    },
  },
  mounted() {
    this.startIdleTimer();
    this.addActivityListeners();
  },
  beforeDestroy() {
    this.destroyListener();
    this.clearIdleTimer();
    this.removeActivityListeners();
  },
  created() {
    this.initOfflineListener({
      pathOffline: 'offline',
      context: this,
    });
  },
  methods: {
    goBackToHome() {
      this.$router.push('/cosrx-vending-machine-event/scan-qr');
    },
    startGame() {
      this.$router.push('/cosrx-vending-machine-event/bbb-game-start');
    },

    startIdleTimer() {
      this.clearIdleTimer();
      this.idleTimer = setTimeout(() => {
        this.handleAutoLogout();
      }, this.idleTimeout);
    },

    clearIdleTimer() {
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
        this.idleTimer = null;
      }
    },

    resetIdleTimer() {
      this.startIdleTimer();
    },

    handleAutoLogout() {
      this.$store
        .dispatch('userLogout')
        .then(() => {
          this.$router.push('/cosrx-vending-machine-event/scan-qr');
        })
        .catch(() => {
          this.$router.push('/cosrx-vending-machine-event/scan-qr');
        });
    },

    addActivityListeners() {
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
      events.forEach((event) => {
        document.addEventListener(event, this.handleUserActivity, true);
      });
    },

    removeActivityListeners() {
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
      events.forEach((event) => {
        document.removeEventListener(event, this.handleUserActivity, true);
      });
    },

    handleUserActivity() {
      this.resetIdleTimer();
    },
  },
};
</script>

<style lang="scss" scoped>
.how-to-play-section {
  // background-color: #e8e8e8;
  padding: 60px 45px;
  border-radius: 10px;
  font-family: 'lato-regular';
  width: 100%;
  box-sizing: border-box;
}

.how-to-play-title {
  font-family: 'Pretendard';
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  color: #000;
  text-align: center;
  margin: 0 0 30px 0;
}

.how-to-play-list {
  font-family: 'Pretendard';
  list-style: none;
  padding: 0;
  margin: 0 auto 30px auto;
  width: 90%;
  overflow: hidden;
  height: auto;
}

.how-to-play-item {
  font-family: 'Pretendard';
  display: block;
  margin-bottom: 25px;
  width: 100%;
  min-height: 60px;
  position: relative;
  padding-left: 70px;
  box-sizing: border-box;
  text-align: left;

  &:last-child {
    margin-bottom: 0;
  }
}

.bullet {
  position: absolute;
  left: 0;
  top: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #fff;
  border: 4px solid #000;
  color: #000;
  font-family: 'Pretendard';
  font-size: 24px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.how-to-play-item p {
  margin: 0;
  color: #000;
  font-family: 'Pretendard';
  font-size: 28px;
  line-height: 36px;
  padding-top: 8px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  width: 100%;
}

.how-to-play-item p b {
  font-family: 'Pretendard';
  font-weight: 700;
}

.button-container {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  clear: both;
}

.btn-back,
.btn-play {
  border-radius: 48px;
  padding: 20px 40px;
  font-family: 'Pretendard';
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  border: 4px solid #000;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-back {
  background: #fff;
  color: #000;

  &:hover {
    background: #f0f0f0;
  }
}

.btn-play {
  background: #6cebfb;
  color: #000;

  &:hover {
    background: #5dd9ea;
  }
}
.bbb-how-to {
  min-height: 100vh;
  background: #000 url('/static/img/cosrx-event/cosrx-event-how-to-play.png') no-repeat top center;
  background-size: 100% auto;
  position: relative;
}
.vn-bg {
  min-height: 100vh;
  background: #000 url('/static/img/cosrx-event/cosrx-event-how-to-play.png') no-repeat top center;
  background-size: 100% auto;
  position: relative;
}
ul {
  display: block;
  margin: 0;
  padding: 0;
  height: 1181px;
  position: relative;
}
ul li {
  display: block;
  margin: 0;
  padding: 0;
  list-style: none;
  font: normal 28px/39px 'Pretendard', 'lato-regular';
  text-align: center;
  color: #fff;
  width: 270px;
  position: absolute;
}
ul li strong {
  display: block;
  font: normal 40px/32px 'Pretendard', 'lato-bold', sans-serif;
  font-weight: 700;
  letter-spacing: 2.6px;
  color: black;
  margin: 0 0 4px;
}
.three-points {
  top: 581px;
  left: 64px;
  p {
    margin-top: 10px;
    color: black;
    font-weight: 500;
  }
}
.two-points {
  top: 581px;
  left: 394px;
  p {
    margin-top: 10px;
    color: black;
    font-weight: 500;
  }
}
.one-point {
  top: 581px;
  left: 719px;
  p {
    margin-top: 10px;
    color: black;
    font-weight: 500;
  }
}
.minus-two-points {
  top: 774px;
  left: 394px;
  p {
    margin-top: 10px;
    color: black;
    font-weight: 500;
  }
}
.comet-vn {
  top: 220px;
  left: 301px;
}
.asteroid-vn {
  top: 464px;
  left: 500px;
}
.meteoroid-vn {
  top: 740px;
  left: 290px;
}
.title {
  margin: 0 auto 57px;
  display: block;
}
ol {
  display: block;
  margin: 0 auto;
  padding: 0;
  width: 880px;
}
ol li {
  min-height: 74px;
  margin: 0 0 22px;
  list-style: none;
  padding: 0 0 0 90px;
  font: normal 30px/36px 'lato-regular', sans-serif;
  position: relative;
  color: #fff;
}
ol li:before {
  content: '';
  position: absolute;
  width: 70px;
  height: 70px;
  top: 0;
  left: 0;
  background-size: cover !important;
}
ol li strong {
  font-family: 'lato-bold', sans-serif;
  color: #eb395f;
}
ol li:nth-child(1):before {
  background: transparent url('/static/img/big-bang-boom/howto-number-1-bbb-store.png') no-repeat center;
}
ol li:nth-child(2):before {
  background: transparent url('/static/img/big-bang-boom/howto-number-2-bbb-store.png') no-repeat center;
}
ol li:nth-child(3):before {
  background: transparent url('/static/img/big-bang-boom/howto-number-3-bbb-store.png') no-repeat center;
}
button {
  display: block;
  width: 685px;
  height: 98px;
  margin: 50px auto 60px;
  border-radius: 48px;
  font: normal 32px 'lato-bold', sans-serif;
  letter-spacing: 3.2px;
  color: #fff;
  background: #d51d6e;
  border: 0;
}
button:focus {
  outline: none;
}
.close-button {
  display: block;
  width: 100px;
  height: 100px;
  position: absolute;
  top: 50px;
  right: 50px;
  z-index: 2;
}
.title-vn {
  font: normal 52px/28px 'SVN-dm-serif-display-regular', sans-serif;
  text-align: center;
  color: #fff;
  margin-bottom: 24px;
}
.strong-vn {
  font-family: $lato-regular, sans-serif;
  color: #eb395f;
  font-weight: normal;
}
.btn-vn {
  font-family: $lato-regular, sans-serif;
  text-transform: uppercase;
  margin: 30px auto 0px;
}
ul.vn li {
  display: block;
  margin: 0;
  padding: 0;
  list-style: none;
  font: normal 28px/39px 'Pretendard', 'lato-bold', sans-serif;
  text-align: center;
  color: #fff;
  width: 290px;
  position: absolute;
}

@media screen and (max-width: 950px) and (min-width: 900px) {
  .three-points {
    top: 500px;
    left: 39px;
  }
  .two-points {
    top: 500px;
    left: 321px;
  }
  .one-point {
    top: 500px;
    left: 602px;
  }
  .minus-two-points {
    top: 654px;
    left: 318px;
  }
  ul {
    display: block;
    margin: 0;
    padding: 0;
    height: 1034px;
    position: relative;
  }
  .how-to-play-section {
    padding: 10px 55px;
  }
  .btn {
    width: 350px;
    height: 79px;
  }
  .button-container {
    margin-top: 5px;
  }
  button {
    margin: 0;
  }
}
</style>
